export default "__VITE_ASSET__uyaAk0LI__"